import {publicReducer, privateReducer, officeReducer} from "./AppReducer";
import storage from 'redux-persist/lib/storage'

const reducerMap = {
    PUBLIC: publicReducer,
    PRIVATE: privateReducer,
    OFFICE: officeReducer,
};

const rootReducer = (state, action) => {

    if (action.type === 'AUTH/LOGOUT_SUCCESS') {
        storage.removeItem('persist:office');
        storage.removeItem('persist:private');
        const newState = { ...state };

        if (newState.app) {
            newState.app = { ...newState.app, config: {}, settings: {}, };
        }

        const selectedReducer = reducerMap.PUBLIC;
        return selectedReducer(newState, action);
    }

    let mode = state?.app?.mode;

    if(action.type === 'APP/INITIALIZE'){
        mode = action.payload;
    }

    const selectedReducer = reducerMap[mode] || reducerMap.PUBLIC;
    return selectedReducer(state, action);
};

export default rootReducer;